<template>
  <div class="row">
    <div class="col-lg-12">
      <StatusModal
        :show.sync="modals.successModal"
        :message="message"
        :title="title"
      />

      <modal :show.sync="modals.submit" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>{{ title }}</h1>
            <p>
              {{ message }}
            </p>
          </div>
        </div>
      </modal>

      <!-- view / edit -->
      <div v-if="$route.params.action == 'edit'">
        <div class="row">
          <div class="col-lg"></div>
          <div class="col-lg-4 d-flex">
            <card class="card-eprf" style="height: 520px; overflow: auto">
              <div class="row">
                <div class="col-lg">
                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                    PTW
                  </p>
                </div>
              </div>

              <p class="newtitle" v-if="displayflag">
                Choose File from Your Desktop
              </p>
              <p v-if="displayflag" style="font-size: 14px; color: #A5A5A5">
                Please upload PTW
              </p>
              <div class="fileinput" v-if="displayflag">
                <label
                  for="ptw-upload"
                  type="primary"
                  class="btn"
                  style="
                    font-size: 13px;
                    color: #ffffff;
                    text-transform: capitalize;
                  "
                >
                  Choose File
                </label>
                <!-- <label  style="color: white" for="file-upload" type="primary" class="btn">
                    Upload
                  </label> -->
                <div
                  class="d-flex justify-content-center spinner"
                  v-if="uploadload == true"
                >
                  <circle-8></circle-8>
                </div>

                <input
                  accept="application/pdf"
                  id="ptw-upload"
                  type="file"
                  ref="ptw"
                  name="..."
                  class="valid"
                  :multiple="true"
                  aria-invalid="false"
                  style="display: none"
                  v-on:change="onPTWChange"
                />
              </div>
              <div
                v-if="uploadload == false"
                class=""
                style="height: 300px; overflow: auto; overflow-x: hidden"
              >
                <div v-for="(filee, index) in allPTW" :key="index" class="row">
                  <div class="col-lg">
                    <div class="row">
                      <div class="col-lg">
                        <a :href="filee.fileurl">
                          <base-button class="btn-link btn-primary text-left">
                            {{ filee.filename }}
                          </base-button>
                        </a>
                      </div>
                      <div class="col-lg-4" v-if="displayflag">
                        <base-button
                          class="btn-sm btn-cancel"
                          style="font-size: 12px"
                          @click="removePTW(filee.fileid)"
                        >
                          Remove
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-lg-4 d-flex">
            <card class="card-eprf" style="height: 520px; overflow: auto">
              <div class="row">
                <div class="col-lg">
                  <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                    eCAF
                  </p>
                </div>
              </div>

              <p class="newtitle" v-if="displayflag">
                Choose File from Your Desktop
              </p>
              <p v-if="displayflag" style="font-size: 14px; color: #A5A5A5">
                Please upload eCAF
              </p>
              <div class="fileinput" v-if="displayflag">
                <label
                  for="ecaf-upload"
                  type="primary"
                  class="btn"
                  style="
                    font-size: 13px;
                    color: #ffffff;
                    text-transform: capitalize;
                  "
                >
                  Choose File
                </label>

                <div
                  class="d-flex justify-content-center spinner"
                  v-if="uploadecaf == true"
                >
                  <circle-8></circle-8>
                </div>

                <input
                  accept="application/pdf"
                  id="ecaf-upload"
                  type="file"
                  ref="ecaf"
                  name="..."
                  class="valid"
                  :multiple="true"
                  aria-invalid="false"
                  style="display: none"
                  v-on:change="oneCAFChange"
                />
              </div>
              <!-- padding: 0px 20px 20px 0px; margin: 0px 30px 20px 0px -->
              <!-- scrollable green flex-grow-1 flex-shrink-0 overflow-auto -->
              <div
                v-if="uploadecaf == false"
                style="height: 300px; overflow: auto; overflow-x: hidden"
                class=""
              >
                <div v-for="(filee, index) in alleCAF" :key="index" class="row">
                  <div class="col-lg">
                    <div class="row">
                      <div class="col-lg text-left">
                        <a :href="filee.fileurl">
                          <base-button class="btn-link btn-primary">
                            {{ filee.filename }}
                          </base-button>
                        </a>
                      </div>
                      <div class="col-lg-4" v-if="displayflag">
                        <base-button
                          class="btn-sm btn-cancel"
                          style="font-size: 12px"
                          @click="removeeCAF(filee.fileid)"
                        >
                          Remove
                        </base-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </card>
          </div>
          <div class="col-lg"></div>
        </div>
        <div class="row">
          <div class="col-lg"></div>
          <div class="col-lg-3 text-right">
            <base-button type="danger" v-on:click="prevTab()">Back</base-button
            >&nbsp;
            <base-button
              type="primary"
              v-on:click="nextTab()"
              v-if="!displayflag"
              >Next</base-button
            >
            &nbsp;
            <base-button
              type="primary"
              v-on:click="submitdoc()"
              v-if="displayflag"
              :disabled="dis"
              >Submit</base-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import { debounce } from "src/util/debounce";
import swal from "sweetalert2";
import moment from "moment";
import { getStorage } from "../../../../../util/storage";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";

export default {
  // props: ["parentData"],
  components: {
    StatusModal,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Circle8,
    Modal,
    BCard,
  },

  data() {
    return {
      // general
      uploadload: false,
      positionid: "",
      status: "",
      displayflag: false,
      // modals
      title: "",
      message: "",

      // PTW

      allPTW: [],

      //eCAF
      uploadecaf: false,
      alleCAF: [],
      dis: false,

      modals: {
        submit: false,
        warningsubmit: false,
        supportdoc: false,
        successModal: false,
      },
    };
  },
  created() {
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );

    if (this.$route.params.action == "edit") {
      this.getData();
    }
  },
  mounted() {},
  computed: {},
  watch: {
    positionid() {
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    status() {
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    alleCAF() {
      if (this.alleCAF == 0 && this.allPTW == 0) {
        this.dis = true;
      } else if (this.alleCAF == 0 && this.allPTW != 0) {
        this.dis = true;
      } else if (this.alleCAF != 0 && this.allPTW == 0) {
        this.dis = true;
      } else if (this.alleCAF != 0 && this.allPTW != 0) {
        this.dis = false;
      }
    },
    allPTW() {
      if (this.alleCAF == 0 && this.allPTW == 0) {
        this.dis = true;
      } else if (this.alleCAF == 0 && this.allPTW != 0) {
        this.dis = true;
      } else if (this.alleCAF != 0 && this.allPTW == 0) {
        this.dis = true;
      } else if (this.alleCAF != 0 && this.allPTW != 0) {
        this.dis = false;
      }
    },
  },

  methods: {
    onPTWChange(e) {
      this.uploadload = true;
      const t = e.target;
      const formData = new FormData();

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("documents", o);
      }
      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" +
            this.$route.params.jobnum +
            "/document/ptw-document",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.title = "Successfull!";
            this.message = "Document successfully uploaded.";
            this.modals.submit = true;
            this.uploadload = false;

            setTimeout(() => {
              this.getData();
              this.modals.submit = false;
            }, 2000);
          }
        });
    },
    removePTW(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.jobnum +
                "/document/ptw-document/" +
                fileid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.title = "Successfull!";
                this.message = response;
                this.modals.successModal = true;
                this.$refs.ptw.value = "";
                this.getData();
                setTimeout(() => {
                  this.modals.successModal = false;
                }, 2000);
              }
            });
        }
      });
    },
    oneCAFChange(e) {
      this.uploadecaf = true;
      const t = e.target;
      const formData = new FormData();

      for (var i = 0; i < t.files.length; i++) {
        let o = t.files[i];

        formData.append("documents", o);
      }
      // to verify form data
      for (var pair of formData.entries()) {
        console.log(pair);
      }

      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" +
            this.$route.params.jobnum +
            "/document/ecaf-document",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("token"),
            },
          }
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.title = "Successfull!";
            this.message = "Document successfully uploaded.";
            this.modals.submit = true;
            this.uploadecaf = false;

            setTimeout(() => {
              this.getData();
              this.modals.submit = false;
            }, 2000);
          }
        });
    },
    removeeCAF(fileid) {
      swal({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-primary btn-fill",
        cancelButtonClass: "btn btn-cancel btn-fill",
        confirmButtonText: "Continue",
        buttonsStyling: false,
      }).then((result) => {
        console.log(result);
        if (result.value == true) {
          this.$http
            .delete(
              ":10001/api/v1/outgoing/waste/" +
                this.$route.params.jobnum +
                "/document/ecaf-document/" +
                fileid
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;
                console.log(response);
                this.title = "Successfull!";
                this.message = response;
                this.modals.successModal = true;
                this.$refs.ecaf.value = "";

                setTimeout(() => {
                  this.getData();
                  this.modals.successModal = false;
                }, 2000);
              }
            });
        }
      });
    },

    redirect() {
      this.$router.push("/Land/Request");
    },

    getData() {
      this.load = true;
      this.allPTW = [];
      this.alleCAF = [];

      this.$http
        .get(":10001/api/v1/outgoing/waste/" + this.$route.params.jobnum)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);

            this.status = response.status.status;

            // get PTW doc
            for (var i = 0; i < response.ptw_document.length; i++) {
              let obj = {
                filename: response.ptw_document[i].meta.filename,
                fileurl: response.ptw_document[i].url,
                fileid: response.ptw_document[i].document_id,
              };
              this.allPTW.push(obj);
            }

            // get eCAF doc
            for (var i = 0; i < response.ecaf_document.length; i++) {
              let obj = {
                filename: response.ecaf_document[i].meta.filename,
                fileurl: response.ecaf_document[i].url,
                fileid: response.ecaf_document[i].document_id,
              };
              this.alleCAF.push(obj);
            }
          }
        });
    },

    prevTab() {
      // this.$router.push("/Outgoing");
      let parameter = {
        step: "4",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    nextTab() {
      let parameter = {
        step: "4",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    submitdoc() {
      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" +
            this.$route.params.jobnum +
            "/ptw_ecaf/submit"
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.nextTab();
          }
        });
    },

    tableRowClassName({ row, rowIndex }) {
      // console.log(rowIndex % 2);
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
  },
};
</script>
<style scoped>
.swcode-text {
  color: #707070;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* Limit the number of lines to 3 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.newtitle {
  color: #707070;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
  /* height: 20px; */
}

.custom-table .el-table__body td,
.custom-table .el-table__header th {
  color: #A5A5A5 !important;
}

.custom-dropdown-2 {
  width: 300px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overlay-content {
  background: transparent;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  z-index: 9999;
}

.link {
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

/* Add this CSS to your stylesheet */
.custom-table .el-table__body-wrapper {
  overflow-y: scroll;
  /* Ensure there is a vertical scrollbar */
}

/* Webkit browsers (Chrome, Safari) */
.custom-table .el-table__body-wrapper::-webkit-scrollbar {
  width: 12px;
  /* Set the width of the scrollbar */
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #358dcc;
  /* Set the color of the scrollbar thumb */
  border-radius: 6px;
  /* Set the border radius of the scrollbar thumb */
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* Set the color of the scrollbar track */
}

.custom-input {
  padding: 5px 5px 5px 5px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}
</style>
